import { DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI } from '../../../types/default-cloud-graph-work-item-entity-ati';
import { type ThirdPartyConfig } from '../../../types/schemas/types';
import { TypeFilterValueKey } from '../../../utils/filters/universalType';
import { get3PLogo } from '../../icons';
import { ProductResourceTypes3P } from '../types';
import { FreshserviceIcon, FreshserviceSearchResultIcon } from './icon';

export const freshserviceConfig: ThirdPartyConfig = {
	displayName: 'Freshservice',
	id: 'freshservice',
	icon: get3PLogo(FreshserviceIcon, 'Freshservice', 'medium'),
	resourceType: ProductResourceTypes3P.Freshservice,
	searchResultIcon: get3PLogo(FreshserviceSearchResultIcon, 'Freshservice', 'large'),
	integrationAri: 'ari:cloud:platform::integration/freshservice', // this hasn't been implemented in the codebase yet, so will need to confirm that it is correct in the future,
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.WorkItem,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI,
				subTypes3P: [],
			},
		],
	]),
	requiresOauth: true,
	isEnabled: () => true,
};
